import axios from "./axiosConfig.js";

const ANALYTICS_ENDPOINT = "analytics/";

// Initialize Mixpanel using require to avoid TypeScript issues
import mixpanel from 'mixpanel-browser';
mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN);

function getBrowserInfo() {
    const userAgent = navigator.userAgent;
    if (!userAgent) {
      return {
        name: "Unknown",
        version: "Unknown",
        platform: "Unknown"
      };
    }
    let browserName = "Unknown";
    let browserVersion = "Unknown";
    let browserPlatform = "Unknown";

  
    let browserVersionArr : string[]= [];
    // Detect browser name and version
    if (userAgent.indexOf("Firefox") > -1) {
      browserName = "Firefox";
      browserVersionArr = userAgent.match(/Firefox\/([0-9.]+)/) || [];
    
    } else if (userAgent.indexOf("Chrome") > -1) {
      browserName = "Chrome";
      browserVersionArr = userAgent.match(/Chrome\/([0-9.]+)/) || [];
    } else if (userAgent.indexOf("Safari") > -1) {
      browserName = "Safari";
      browserVersionArr = userAgent.match(/Version\/([0-9.]+)/) || [];
     
    } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident/") > -1) {
      browserName = "Internet Explorer";
      browserVersionArr = userAgent.match(/(?:MSIE |rv:)(\d+(\.\d+)?)/) || []
    } else if (userAgent.indexOf("Edge") > -1) {
      browserName = "Edge";
      browserVersionArr = userAgent.match(/Edge\/([\d.]+)/) || [];
    }

    if (browserVersionArr.length > 1) {
      browserVersion = browserVersionArr[1];
    }
  
    // Detect browser platform (Windows, Mac, Linux, Android, iOS)
    if (userAgent.indexOf("Win") > -1) {
      browserPlatform = "Windows";
    } else if (userAgent.indexOf("Mac") > -1) {
      browserPlatform = "MacOS";
    } else if (userAgent.indexOf("Linux") > -1) {
      browserPlatform = "Linux";
    } else if (userAgent.indexOf("Android") > -1) {
      browserPlatform = "Android";
    } else if (userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("iPad") > -1 || userAgent.indexOf("iPod") > -1) {
      browserPlatform = "iOS";
    }
  
    return {
      name: browserName,
      version: browserVersion,
      platform: browserPlatform
    };
  }

let lastEventTime: { [key: string]: number } = {};

export const trackEvent = async(event: string, properties?: any) => {
    const now = new Date().getTime();
    // Prevent duplicate events within 100ms
    if (lastEventTime[event] && now - lastEventTime[event] < 100) {
        return;
    }
    lastEventTime[event] = now;
    
    let sessionId = localStorage?.getItem("sessionId")
    
    if (!sessionId) {
        sessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
        localStorage?.setItem("sessionId", sessionId)
    } 

    const browserInfo = getBrowserInfo();
    const response = await axios.post(ANALYTICS_ENDPOINT + "track", {eventName: event, uuid: sessionId, properties: {
        city: Intl.DateTimeFormat().resolvedOptions().timeZone,
        os: browserInfo.platform,
        browser: browserInfo.name,
        version: browserInfo.version,
        ...properties
    }})
    if (response.status !== 200) {
        throw new Error(response.statusText)
    }
}

// Note: Identification APIs are called directly by the client, not sent through the backend.
// This is as-dictated by Mixpanel's docs: https://docs.mixpanel.com/docs/tracking-methods/sdks/nodejs

export const identifyUser = async (name: string, email: string, username: string, isPlus: boolean, birthday?: Date | string | null) => {
    try {
        // Identify the user with their UUID
        mixpanel.identify(username);

        // Set user properties
        mixpanel.people.set({
            $name: name,
            $email: email,
            $username: username,
            subscribed: isPlus,
            ...(birthday && { birthday })
        });
    } catch (error) {
        console.error("Failed to identify user in analytics:", error);
    }
}

export const resetUser = async (uuid: string) => {
    try {
        // Reset the user's identity
        mixpanel.reset();
    } catch (error) {
        console.error("Failed to reset user in analytics:", error);
    }
}
